import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'
import ProjectService, { ProjectStructure } from '../../services/ProjectService'

export const useProjectsStructure = () => {
  const { org } = useParams()
  return useQuery<ProjectStructure[]>({
    queryKey: ['projects-structure', org],
    queryFn: () => ProjectService.listProjectsStructure(org!),
    enabled: !!org,
  })
}
